import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectCreateArgs } from "types/generated";

import { INTENT_PROJECT_BASIC_FRAGMENT } from "../gql";

export const CREATE_INTENT_PROJECT: TypedDocumentNode<
  { intentProjectCreate: IntentProject },
  MutationIntentProjectCreateArgs
> = gql`
  mutation CreateIntentProject($name: String!, $description: String, $space: ID!) {
    intentProjectCreate(name: $name, description: $description, space: $space) {
      ...IntentProjectBasic
    }
  }
  ${INTENT_PROJECT_BASIC_FRAGMENT}
`;
